/*=============================================== PageLoadingPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const PageLoadingPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    <Link
                        to="/components/page-loading/demo"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: "<PageLoading />",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "backgroundColor",
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
        {
            subtitle: "loaderColor",
            type: "string",
            possibleString: commonProps.allColors,
            default: "white",
        },
        {
            subtitle: "loaderVariant",
            type: "number",
            possible: [1, 2, 3, 4],
            default: 1,
        },
        {
            subtitle: "stopScrolling",
            intro: (
                <>
                    Disable <code>scroll</code> on the page.
                </>
            ),
            type: "boolean",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default PageLoadingPage
